// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Custom emoji button styling */
.ql-toolbar .ql-emoji {
  width: 28px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ql-toolbar .ql-emoji svg {
  width: 18px;
  height: 18px;
}

.ql-toolbar .ql-emoji .ql-fill {
  fill: #444;
}

.ql-toolbar .ql-emoji .ql-stroke {
  stroke: #444;
  stroke-width: 1.5;
}

`, "",{"version":3,"sources":["webpack://./src/components/Editor/emojiButton.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB","sourcesContent":["/* Custom emoji button styling */\n.ql-toolbar .ql-emoji {\n  width: 28px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.ql-toolbar .ql-emoji svg {\n  width: 18px;\n  height: 18px;\n}\n\n.ql-toolbar .ql-emoji .ql-fill {\n  fill: #444;\n}\n\n.ql-toolbar .ql-emoji .ql-stroke {\n  stroke: #444;\n  stroke-width: 1.5;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
